module.exports = __webpack_public_path__ + "static/media/works2.b12776a9.png";